
class TrackingError {
  getError(type, label) {
    let typeData;
    let labelData;
    if (type) {
      typeData = type;
    }
    if (label) {
      labelData = label;
    }
    return {type: typeData, label: labelData};
  }
  
  getErrors(errorsList) {
    let dataList;
    if (errorsList) {
      dataList = errorsList;
    }
    
    return {
      errors: dataList,
    };
  }
}

export default new TrackingError();
